export default [
    {
        date: 1579963533442,
        row: 4,
        col: 4,
        segments: [
            [1, 2, 2, 2],
            [2, 1, 2, 2],
            [2, 1, 3, 1],
            [3, 1, 3, 2],
            [3, 2, 4, 2],
            [4, 2, 4, 3],
            [4, 3, 3, 3],
            [3, 3, 3, 4],
            [3, 4, 2, 4],
            [2, 4, 2, 3],
            [2, 3, 1, 3],
            [1, 3, 1, 2],
        ],
    },
    {
        date: 1494506296173,
        row: 4,
        col: 4,
        segments: [
            [4, 1, 1, 4],
            [2, 4, 2, 3],
            [3, 2, 3, 1],
            [3, 2, 4, 2],
            [3, 3, 2, 2],
            [2, 2, 2, 3],
            [2, 3, 3, 3],
            [3, 3, 3, 2],
            [3, 2, 2, 2],
            [1, 3, 1, 1],
            [1, 2, 1, 4],
            [1, 4, 2, 4],
            [2, 4, 3, 4],
            [3, 4, 4, 4],
            [4, 4, 4, 1],
            [1, 1, 4, 1],
            [2, 2, 1, 3],
            [3, 3, 2, 4],
            [3, 3, 4, 2],
            [2, 2, 3, 1],
            [2, 2, 1, 1],
            [3, 3, 4, 4],
            [4, 4, 3, 1],
            [4, 4, 1, 3],
            [1, 3, 2, 3],
            [1, 3, 3, 2],
            [2, 3, 3, 1],
            [2, 2, 2, 1],
            [1, 2, 2, 2],
            [3, 1, 4, 2],
            [2, 4, 1, 3],
            [3, 4, 4, 2],
            [4, 3, 2, 4],
        ],
    },
    {
        date: "1462631327552",
        row: 4,
        col: 4,
        segments: [
            [1, 2, 4, 2],
            [2, 1, 3, 1],
            [2, 1, 1, 2],
            [3, 1, 4, 2],
            [1, 4, 1, 2],
            [1, 4, 4, 4],
            [4, 2, 4, 4],
        ],
    },
];
